<template>
  <section class="section has-text-centered">
    <h1 class="title">
      404
    </h1>
    <h2 class="subtitle">
      This page does not exist!
    </h2>
    <router-link to="/">
      Return to Homepage
    </router-link>
  </section>
</template>

<script>
export default {}
</script>

<style>

</style>
